import React from 'react';

export default class RenderInBatches extends React.Component {
  render() {
    const { children, first, by } = this.props;
    return (
      <React.Fragment>
        <Batch
          numOfBatches={(children.length - first) / by + 2}
          batchesRendered={0}
          first={first}
          by={by}
          cb={this.callback}
        >
          {children}
        </Batch>
      </React.Fragment>
    );
  }
}

class Batch extends React.Component {
  state = {
    thisBatchRendered: false,
  };

  componentDidMount() {
    this.callback();
  }

  callback = async () => {
    const wait = ms => new Promise(res => setTimeout(res, ms));
    await wait(0);
    this.setState({
      thisBatchRendered: true,
    });
  };

  render() {
    const { numOfBatches, batchesRendered, first, by, children, ...rest } = this.props;
    const start = batchesRendered === 0 ? 0 : first + (batchesRendered - 1) * by;
    const end = first + batchesRendered * by;
    return (
      <React.Fragment>
        {children.slice(start, end)}
        {this.state.thisBatchRendered && numOfBatches > batchesRendered ? (
          <Batch
            numOfBatches={numOfBatches}
            batchesRendered={batchesRendered + 1}
            first={first}
            by={by}
            {...rest}
          >
            {children}
          </Batch>
        ) : null}
      </React.Fragment>
    );
  }
}
